<h1 mat-dialog-title class="editHeader text-center blueHeader dialogHeader text-white">{{headerTitle}}</h1>
<mat-dialog-content class="mb-4">
  <div class="mt-3">
    <div class="col-md-12 mb-1">
      <label for="firstName" class="payingClinic col-md-6">Doctor: </label>
      <label class="payingClinic col-md-6">{{subscriptionData?.doctor?.first_name}}
        {{subscriptionData?.doctor?.last_name}}</label>
    </div>
    <div class="col-md-12 mb-1">
      <label for="paymentDate" class="payingClinic col-md-6">Extended Date: </label>
      <div class="col-md-6 d-inline-block text-center payDate">
        <my-date-picker name="paymentDate" [options]="myDatePickerOptions" [(ngModel)]="paymentDate"
          (dateChanged)="onPaymentDateChanged($event)" placeholder="Extended Date">
        </my-date-picker>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="ml-4">
    <button mat-button class="mat-raised-button mr-4  btnWidth btn blankTurquoise"
      (click)="dialogRef.close(false)">Cancel</button>
    <button mat-button class="mat-raised-button mr-4 btn turquoiseBtn btnWidth btn-sm updateButton"
      (click)="activateSubscription()">Activate</button>
  </div>
</mat-dialog-actions>
